import React from 'react';
import { getTargetingTooltip } from 'utils/helpers';
import { UINoteIcon } from 'components/UINoteIcon';
import { withDictionarySelect } from '../../../../../HOC/withDictionarySelect';
import { API } from '../../../../../api';

export const SelectInventoryGroupWrapper = withDictionarySelect(
  API.Inventory.Groups,
  null,
  true,
  true,
  (type: 'include' | 'exclude') => (
    <UINoteIcon
      text={getTargetingTooltip(type === 'include' ? 'targeted' : 'blocked', 'inventories')}
      marginLeft={1}
    />
  ),
);
